import { AxiosResponse } from 'axios';
import BaseApi from './BaseApi';
import IVisitSlot from '../Models/IVisitSlot';
import IBookedVisitSlot from '../Models/IBookedVisitSlot';

/**
 * The document API class.
 * 
 * @class
 * @param {string} _bearer The connected user bearer.
 */
class OpeningHoursApi extends BaseApi {
	constructor() {
        super('openinghours');
	}
	
	/** 
	 * Get the opening hours
	 * 
	 * @return {Promise} The request promise.
	*/
	public getOpeningHours = (): Promise<any> => {		
		return this._get('', {});
	}
	
	/** 
	 * Get the opening hours for visits
	 * 
	 * @return {Promise} The request promise.
	*/
	public getBookingOpeningHours = (): Promise<AxiosResponse<IVisitSlot[]>> => {				
		return this._get('bookings', {});
	}

	/** 
	 * Get booked visits
	 * 
	 * @return {Promise} The request promise.
	*/
	public getBookedVisits = (): Promise<AxiosResponse<IBookedVisitSlot[]>> => {				
		return this._get('booked', {});
	}


	/** 
	 * Get slots for birthdays
	 * 
	 * @return {Promise} The request promise.
	*/
	public getBirthdayBookingOpeningHours = (): Promise<AxiosResponse<IVisitSlot[]>> => {				
		return this._get('birthdays', {});
	}
	
	/** 
	 * Get slots for groups
	 * 
	 * @return {Promise} The request promise.
	*/
	public getGroupsBookingOpeningHours = (start: string, end: string): Promise<AxiosResponse<IVisitSlot[]>> => {				
		return this._get('groups', {
			start,
			end
		});
	}
	
	/** 
	 * Get reserved slots for groups
	 * 
	 * @return {Promise} The request promise.
	*/
	public getReservedGroupsBookings = (date: string): Promise<AxiosResponse<string[]>> => {				
		return this._get('groups/reservations', { date });
	}
}

export default OpeningHoursApi;